import BackendService from './BackendService';
import { HEADERS, STORAGE_KEYS, CLARITY_EVENTS } from 'const';
import AnalyticsHelper from 'helpers/AnalyticsHelper';

async function login(username, password) {
  const reqData = { username, password };
  try {
    const responseData = await BackendService.post('/login/', reqData, {
      'User-Interface': 'ios',
    });

    const data = responseData.data;
    if (data.status !== undefined && data.status !== 200) {
      const error = new Error(data.message || 'Login failed');
      error.response = { data };
      throw error;
    }
    if (!data.token) {
      return new Error('Failed generate auth token from server');
    }
    localStorage.setItem(STORAGE_KEYS.TOKEN, data.token);

    AnalyticsHelper.identify(data.user);
    AnalyticsHelper.event(CLARITY_EVENTS.LOGIN);
  } catch (error) {
    AnalyticsHelper.event(CLARITY_EVENTS.LOGIN_FAILED);
    return error;
  }
}
async function logout(data = {}) {
  const token = localStorage.getItem(STORAGE_KEYS.TOKEN);
  localStorage.clear();

  if (!token) return;
  try {
    return BackendService.destroy('/logout/', null, {
      [HEADERS.AUTH]: `Token ${token}`,
    });
  } catch (error) {
    console.error(error);
  }
}
async function resetPassword(data) {
  return BackendService.postData('/resetpassword/', data);
}
async function createAccount(reqData, params = {}) {
  try {
    const responseData = await BackendService.post('/register/', reqData, {}, params);
    
    const data = responseData.data || responseData;
    const token = data.token || responseData.token || data.access_token || responseData.access_token || data.access || responseData.access;
    const shopId = data?.shop?.id || responseData?.shop?.id;
    
    if (data.status && data.status !== 200) {
      return data.message || 'Registration failed';
    }
    
    if (token) {
      localStorage.setItem(STORAGE_KEYS.TOKEN, token);
    }
    if (shopId) {
      localStorage.setItem(STORAGE_KEYS.SHOP_ID, shopId);
    }

    AnalyticsHelper.identify(data.user || responseData.user);
    AnalyticsHelper.event(CLARITY_EVENTS.SIGN_UP);
  } catch (error) {
    AnalyticsHelper.event(CLARITY_EVENTS.SIGN_UP_FAILED);
    return error;
  }
}

const findCountryCode = () => {
  return BackendService.getData('/public/country-code/');
};

const AuthService = {
  login,
  logout,
  resetPassword,
  createAccount,
  findCountryCode,
};

export default AuthService;
